import React, { useState, useEffect } from 'react';
import { Layout } from '../components/Layout';
import { Card, CardContent } from '../components/ui/card';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useApi } from '../hooks/useApi';
import DoctorForm from '../components/DoctorForm';

export default function DoctorEditPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const api = useApi();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [doctor, setDoctor] = useState(null);

  useEffect(() => {
    loadDoctor();
    // eslint-disable-next-line
  }, [id]);

  const loadDoctor = async () => {
    try {
      setLoadingData(true);
      const data = await api.get(`/doctors/${id}`);
      setDoctor(data);
    } catch (error) {
      console.error('Failed to load doctor:', error);
      toast.error('Failed to load professional data');
      navigate('/doctors');
    } finally {
      setLoadingData(false);
    }
  };

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const payload = {
        ...formData,
        opd_charge_nepali: formData.opd_charge_nepali ? parseFloat(formData.opd_charge_nepali) : null,
        opd_charge_international: formData.opd_charge_international ? parseFloat(formData.opd_charge_international) : null,
        online_charge_nepali: formData.online_charge_nepali ? parseFloat(formData.online_charge_nepali) : null,
        online_charge_international: formData.online_charge_international ? parseFloat(formData.online_charge_international) : null,
        email: formData.email || null,
        mobile_number: formData.mobile_number || null,
        nmc_id: formData.nmc_id || null
      };

      await api.put(`/doctors/${id}`, payload);
      toast.success('Professional updated successfully');
      navigate('/doctors');
    } catch (error) {
      console.error('Failed to update:', error);
      toast.error(error.response?.data?.detail || 'Failed to update professional');
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) {
    return (
      <Layout>
        <div className="flex justify-center items-center h-96">
          <Loader2 className="h-8 w-8 animate-spin text-purple-600" />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="p-6 max-w-4xl mx-auto">
        <div className="mb-6">
          <button onClick={() => navigate('/doctors')} className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4">
            <ArrowLeft className="h-4 w-4" />
            <span>Back to Doctor Management</span>
          </button>
          <h1 className="text-2xl font-bold" style={{ color: "#652D90" }}>
            Edit Professional
          </h1>
          <p className="text-gray-600 mt-1">Update the details for {doctor?.full_name}</p>
        </div>

        <Card>
          <CardContent className="p-6">
            <DoctorForm
              initialData={doctor}
              onSubmit={handleSubmit}
              onCancel={() => navigate('/doctors')}
              loading={loading}
            />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
